import { Alert, Button } from 'antd';
import React from "react";
import { Link, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { generateRouteUrl } from '../../../library/constants';
import style from './proof-rejected.module.scss';

const ProofRejected = () => {
    const { orderDetails } = useRouteLoaderData('OrderManagerDetailsPage')
    const { getClientArtworks } = useOutletContext()
    return (
        <div className={style.container}>
            <h3>Task for you</h3>
            <Alert message="Proof has been rejected." type="error"
                action={
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <Button className={style.greenButton} onClick={getClientArtworks}>View Artwork</Button>
                        <Link to={generateRouteUrl('CustomerArtworkToVendor', {
                            itemId: orderDetails.id,
                        })} >
                            <Button className={style.greenButton}>Re - Request Proof</Button>
                        </Link>
                    </div>
                } />
        </div>
    )
}

export default ProofRejected;